<template>
    <div class="pt-2">
        <template v-if="loading">
            <v-row no-gutters>
                <v-col cols="12" class="pt-3 d-flex justify-center">
                    <v-progress-circular color="primary" indeterminate class="mr-3" />
                </v-col>
            </v-row>
        </template>
        <template v-else-if="formErrorMessage">
            <v-row no-gutters>
                <v-col cols="1" class="d-flex align-center justify-center">
                    <v-btn-back class="mr-4" @click.stop="getBackAction()"> </v-btn-back>
                </v-col>
                <v-col cols="11" class="pt-3 d-flex justify-center">
                    <b>{{ formErrorMessage }}</b>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-row no-gutters v-if="!auditForm && !hideHeader" class="default_card_wm ma-2 py-2">
                <v-col
                    :cols="!vatItems && !assistVatItems ? 10 : 9"
                    class="d-flex align-center justify-start"
                >
                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="1">
                            <v-btn-back class="mx-2" @click.stop="getBackAction()"> </v-btn-back>
                        </v-col>
                        <v-col :cols="!vatItems && !assistVatItems ? 9 : 8" class="align-center">
                            <v-row no-gutters>
                                <h2>
                                    {{ form.title ? `${form.title} - ${form.year}` : "" }}
                                </h2>
                            </v-row>
                            <v-row v-if="errorMessage" no-gutters class="my-2">
                                <b style="color: red">{{ errorMessage }}</b>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-spacer />
                <v-col
                    :cols="!vatItems && !assistVatItems ? 2 : 3"
                    class="d-flex align-center justify-end px-3"
                >
                    <v-btn-primary
                        rounded
                        elevation="0"
                        dark
                        size="small"
                        class="mx-1"
                        v-if="autoDepositButtonDisplay"
                        @click="autoDepositValidationDialog = true"
                        icon="$fa-magic"
                    >
                    </v-btn-primary>
                    <v-btn
                        rounded
                        elevation="0"
                        v-if="!vatItems && form.title"
                        :disabled="
                            !['EDITION', 'ERROR'].includes(status) || cerfaNumber === '3030SD'
                        "
                        @click="save(false)"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>
                    <v-btn
                        rounded
                        elevation="0"
                        :disabled="isDisabledValidateButton()"
                        @click="
                            setAmountToPay();
                            toggleConfirmDialog();
                        "
                        class="mx-1"
                        size="small"
                        v-if="form.title"
                    >
                        Valider et payer
                    </v-btn>
                    <v-btn
                        rounded
                        elevation="0"
                        @click="toggleConfirmWithoutSendingDialog()"
                        class="ml-1"
                        size="small"
                        v-if="form.title"
                    >
                        Valider sans envoyer
                    </v-btn>
                </v-col>
            </v-row>
        </template>
        <div
            :style="
                !auditForm
                    ? 'height: 78vh; overflow-y: auto; border-top-left-radius: 25px; border-top-right-radius: 25px;'
                    : ''
            "
        >
            <v-form v-model="valid">
                <!-- <v-row no-gutters v-if="dataLoaded" :key="reloadKey" style="height: calc(100vh - 137px); overflow-y: auto"> -->
                <v-row no-gutters :key="reloadKey">
                    <v-col
                        v-for="table of form.tables"
                        :key="table.title"
                        :cols="$vuetify.display.smAndDown ? 12 : table.size || 12"
                        class="pa-2"
                    >
                        <div v-if="table && table.empty" />
                        <div v-else>
                            <v-col v-if="table.title" cols="12" class="d-flex px-6 py-4">
                                <h3>
                                    {{ table.title }}
                                </h3>
                                <v-spacer v-if="table.expandable" />
                                <v-btn
                                    v-if="table.expandable"
                                    @click="table.expanded = !table.expanded"
                                    style="width: 40px"
                                    class="d-inline px-2"
                                    :icon="
                                        table.expanded
                                            ? '$keyboard_arrow_up'
                                            : 'keyboard_arrow_down'
                                    "
                                >
                                </v-btn>
                            </v-col>
                            <v-card
                                v-if="!table.expandable || table.expanded"
                                class="default_card_wm fill-height"
                                elevation="0"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" v-for="row of table.rows" :key="row.key">
                                        <h3 v-if="row.title" class="d-flex px-6">
                                            {{ row.title }}
                                        </h3>
                                        <v-row
                                            no-gutters
                                            v-else
                                            :class="
                                                isSubTitle(row) ? 'pl-6 py-1 pt-2' : 'py-1 hover'
                                            "
                                        >
                                            <template v-if="isSubTitle(row)">
                                                <v-col
                                                    :cols="row.cols || 6"
                                                    class="d-flex headline font-weight-bold titleclass"
                                                >
                                                    <!-- <span class="pr-2" v-if="row.key">{{ row.key}}</span>{{ row.description }} -->
                                                    {{ row.description }}
                                                    <!-- <span class="pr-2" v-if="row.key">{{ row.description }}</span> -->
                                                </v-col>
                                            </template>
                                            <template v-else>
                                                <v-col
                                                    v-if="row.code"
                                                    cols="1"
                                                    class="d-flex align-center justify-center headline"
                                                >
                                                    <h5>{{ row.code }}</h5>
                                                </v-col>
                                                <v-col
                                                    :cols="row.cols || 5"
                                                    class="d-flex align-center pl-2"
                                                >
                                                    {{ row.description }}
                                                </v-col>
                                            </template>
                                            <template v-if="row.values">
                                                <v-col
                                                    class="d-flex align-center justify-center px-1"
                                                    v-for="field of row.values"
                                                    :key="field.key"
                                                >
                                                    <template v-if="field.type === 'textarea'">
                                                        <v-row>
                                                            <v-col cols="3" />
                                                            <v-col cols="9">
                                                                <v-textarea-filled
                                                                    no-resize
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="fields[field.key]"
                                                                    outlined
                                                                    dense
                                                                    hide-details="auto"
                                                                    :mandatory="field.mandatory"
                                                                    :readonly="
                                                                        isReadonly(field) ||
                                                                        autoVatMode ||
                                                                        readonly
                                                                    "
                                                                    :label="field.label"
                                                                    @update:model-value="
                                                                        reloadField(field)
                                                                    "
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                    <template v-else-if="field.type === 'radio'">
                                                        <v-radio-group
                                                            v-model="fields[field.key]"
                                                            inline
                                                            :rules="[
                                                                (v) =>
                                                                    !!v ||
                                                                    'Tous les champs sont obligatoires',
                                                            ]"
                                                            hide-details="auto"
                                                            :class="
                                                                field.values.length === 2 &&
                                                                field.values[0].value === 'yes'
                                                                    ? 'mt-0 pl-6'
                                                                    : 'mt-0'
                                                            "
                                                            color="primary"
                                                        >
                                                            <v-radio
                                                                v-for="n in field.values"
                                                                :key="n.value"
                                                                @update:model-value="
                                                                    reloadField(field)
                                                                "
                                                                :readonly="
                                                                    isReadonly(field) ||
                                                                    autoVatMode ||
                                                                    readonly
                                                                "
                                                                outlined
                                                                content-class="oss- oss-text-field"
                                                                dense
                                                                :value="n.value"
                                                            >
                                                                <template v-slot:label>
                                                                    <div style="font-size: 14px">
                                                                        {{ n.text }}
                                                                    </div>
                                                                </template>
                                                            </v-radio>
                                                        </v-radio-group>
                                                    </template>
                                                    <template v-else-if="field.type === 'date'">
                                                        <oss-date-picker-filled
                                                            v-if="field.key === 'startDate'"
                                                            filter-with-closed-accounting-periods
                                                            hide-details="auto"
                                                            :disabled="
                                                                getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    status,
                                                                )
                                                            "
                                                            text-field-class="oss-text-field"
                                                            :mandatory="field.mandatory || false"
                                                            :readonly="isReadonly(field)"
                                                            :textFieldReadOnly="false"
                                                            :label="field.label"
                                                            @update:model-value="reloadField(field)"
                                                            :model-value="startDate"
                                                        />
                                                        <oss-date-picker-filled
                                                            v-else-if="field.key === 'endDate'"
                                                            filter-with-closed-accounting-periods
                                                            hide-details="auto"
                                                            :disabled="
                                                                getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    status,
                                                                )
                                                            "
                                                            text-field-class="oss-text-field"
                                                            :mandatory="field.mandatory || false"
                                                            :readonly="isReadonly(field)"
                                                            :textFieldReadOnly="false"
                                                            :label="field.label"
                                                            @update:model-value="reloadField(field)"
                                                            :model-value="endDate"
                                                        />
                                                        <oss-date-picker-filled
                                                            v-else
                                                            v-model="fields[field.key]"
                                                            filter-with-closed-accounting-periods
                                                            hide-details="auto"
                                                            :disabled="
                                                                getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    status,
                                                                )
                                                            "
                                                            text-field-class="oss-text-field"
                                                            :mandatory="field.mandatory || false"
                                                            :readonly="isReadonly(field)"
                                                            :textFieldReadOnly="false"
                                                            :label="field.label"
                                                            @update:model-value="reloadField(field)"
                                                        />
                                                    </template>
                                                    <template v-else-if="field.type === 'boolean'">
                                                        <v-checkbox
                                                            v-model="fields[field.key]"
                                                            @update:model-value="reloadField(field)"
                                                            :readonly="
                                                                isReadonly(field) || autoVatMode
                                                            "
                                                            hide-details
                                                            :false-value="''"
                                                            :true-value="'X'"
                                                            :label="field.label"
                                                            class="mt-0 pt-0 mx-2"
                                                            size="small"
                                                            color="primary"
                                                        />
                                                    </template>
                                                    <template v-else-if="field.type === 'string'">
                                                        <v-text-field-filled
                                                            v-model="fields[field.key]"
                                                            outlined
                                                            hide-details
                                                            :mandatory="field.mandatory"
                                                            :readonly="
                                                                isReadonly(field) || autoVatMode
                                                            "
                                                            :label="field.label"
                                                            @update:model-value="reloadField(field)"
                                                            density="compact"
                                                        />
                                                    </template>
                                                    <template v-else-if="field.type === 'title'">
                                                        <v-col class="text-center .subtitle-2">
                                                            <h4>
                                                                {{ field.default }}
                                                            </h4>
                                                        </v-col>
                                                    </template>
                                                    <template v-else-if="field.type === 'text'">
                                                        <v-col>
                                                            {{ field.default }}
                                                        </v-col>
                                                    </template>
                                                    <template
                                                        v-else-if="field.type === 'percentage'"
                                                    >
                                                        <v-text-field-filled
                                                            v-model="field.default"
                                                            outlined
                                                            hide-details
                                                            :mandatory="field.mandatory"
                                                            :readonly="
                                                                isReadonly(field) || autoVatMode
                                                            "
                                                            :label="field.label"
                                                            @update:model-value="reloadField(field)"
                                                            density="compact"
                                                        />
                                                    </template>
                                                    <template v-else-if="field.type === 'empty'">
                                                        <div />
                                                    </template>
                                                    <template v-else-if="field.type === 'selector'">
                                                        <v-select-filled
                                                            v-if="
                                                                decId &&
                                                                field.key === 'period' &&
                                                                startDate === endDate
                                                            "
                                                            v-model="fields[field.key]"
                                                            :items="field.items"
                                                            outlined
                                                            content-class="oss-text-field"
                                                            hide-details="auto"
                                                            required
                                                            :label="field.label"
                                                            :mandatory="field.mandatory || false"
                                                            :readonly="
                                                                isReadonly(field) || autoVatMode
                                                            "
                                                            :rules="
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            "
                                                            :disabled="field.key === 'period'"
                                                            density="compact"
                                                        />
                                                        <v-select-filled
                                                            v-else
                                                            v-model="fields[field.key]"
                                                            :items="field.items"
                                                            item-title="text"
                                                            item-value="value"
                                                            outlined
                                                            content-class="oss-text-field"
                                                            hide-details="auto"
                                                            required
                                                            :label="field.label"
                                                            :mandatory="field.mandatory || false"
                                                            :readonly="
                                                                isReadonly(field) || autoVatMode
                                                            "
                                                            :rules="
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            "
                                                            :disabled="
                                                                getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) || field.readonly
                                                            "
                                                            :model-value="startDate.substring(5, 7)"
                                                            density="compact"
                                                        />
                                                    </template>
                                                    <template v-else-if="field.type !== 'radio'">
                                                        <oss-text-field-filled
                                                            outlined
                                                            v-model="fields[field.key]"
                                                            hide-details="auto"
                                                            :disabled="field.disabled || false"
                                                            :readonly="
                                                                isReadonly(field) ||
                                                                (autoVatMode && field.key !== 'JB')
                                                            "
                                                            :mandatory="
                                                                getMandatoryConditionField(
                                                                    field.mandatoryConditionField,
                                                                )
                                                            "
                                                            :label="field.label || field.key"
                                                            :rules="
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            "
                                                            :hint="getHint(field)"
                                                            :persistent-hint="!!getHint(field)"
                                                            @update:model-value="reloadField(field)"
                                                        />
                                                    </template>
                                                </v-col>
                                            </template>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </div>
        <oss-dialog
            v-model="confirmWithoutSendingDialog"
            title="Confirmation"
            @valid="validateWithoutSendingToMTAE()"
            validTitle="Valider sans télédéclarer"
        >
            <div style="width: 750px">
                <v-row no-gutters>
                    <b class="text-center">
                        &#xca;tes-vous sûr(e) de vouloir valider la déclaration sans la télédéclarer
                        ni la payer ? Les éventuelles écritures comptables seront générées
                        automatiquement.
                    </b>
                </v-row>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="confirmDialog"
            title="Confirmation"
            @valid="generate()"
            :validTitle="validDeclarationTitle"
        >
            <div style="width: 750px">
                <v-row no-gutters>
                    <v-col cols="12">
                        <div v-if="amountToPay > 0 && !bankAccounts.length">
                            <b style="color: red" class="text-center">
                                Envoi d'un paiement impossible car aucun compte bancaire valide
                                renseigné dans le dossier. L'envoi de la déclaration seule reste
                                possible.
                            </b>
                        </div>
                        <div v-else>
                            <div v-if="amountToPay === 0 || cerfaNumber === '2573SD'">
                                <v-row no-gutters class="mb-2">
                                    <v-col cols="12">
                                        <b class="text-center">
                                            &#xca;tes-vous sûr(e) de vouloir envoyer la déclaration
                                            ?
                                        </b>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-else>
                                <v-row no-gutters class="mb-2">
                                    <b>Montant à payer : {{ amountToPay }}</b>
                                </v-row>
                                <v-row no-gutters class="mb-4">
                                    <b>Montant restant à répartir :</b>
                                    <!-- <span :style="unaffectedPaymentAmount < 0 ? 'color: red;' : ''">{{ unaffectedPaymentAmount < 0 ? unaffectedPaymentAmount + ". Le montant du paiement ne peut pas être supérieur au montant dû." : unaffectedPaymentAmount }}</span></h4> -->
                                </v-row>
                                <v-row
                                    no-gutters
                                    v-for="(line, index) of paymentsList"
                                    :key="index"
                                    class="mb-2"
                                >
                                    <v-col cols="1" />
                                    <v-col cols="6" class="d-flex justify-center align-center pr-1">
                                        <v-select-filled
                                            v-model="line.bankAccountId"
                                            :items="bankAccounts"
                                            item-title="name"
                                            item-value="id"
                                            :item-disabled="isItemDisabled"
                                            outlined
                                            class="text-field"
                                            hide-details="auto"
                                            required
                                            label="Compte bancaire"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="d-flex justify-center align-center pl-1">
                                        <oss-text-field-filled
                                            v-model="line.amount"
                                            outlined
                                            dense
                                            hide-details
                                            label="Montant"
                                        />
                                    </v-col>
                                    <v-col cols="2" class="d-flex">
                                        <v-btn-trash
                                            depressed
                                            class="mx-2 my-2"
                                            rounded="circle"
                                            @click="deletePaymentLine(index)"
                                            v-if="index > 0"
                                            size="x-small"
                                        >
                                        </v-btn-trash>
                                        <v-btn-add-icon
                                            depressed
                                            class="mx-2 my-2"
                                            size="x-small"
                                            fab
                                            @click="addPaymentLine()"
                                            v-if="
                                                index === paymentsList.length - 1 &&
                                                paymentsList.length < bankAccounts.length
                                            "
                                            :disabled="!line.amount || !line.bankAccountId"
                                        >
                                        </v-btn-add-icon>
                                    </v-col>
                                    <v-col cols="12" class="pt-4">
                                        <div v-if="!line.bankAccountId">
                                            <b style="color: red" class="text-center">
                                                Envoi d'un paiement impossible car aucun compte
                                                bancaire sélectionné dans la liste. L'envoi de la
                                                déclaration seule reste possible.
                                            </b>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="autoDepositValidationDialog"
            v-if="autoDepositValidationDialog"
            title="Suggestion"
            @valid="fillAutoDepositInDeclaration()"
            @close="autoDepositValidationDialog = false"
            validTitle="Appliquer"
        >
            <div style="width: 750px">
                <v-row no-gutters v-if="cerfaNumber === '3514SD'">
                    <v-col cols="12">
                        <b class="text-center">
                            bobbee a trouvé le montant de l'acompte à déclarer :
                            {{ vatAutoDepositAmount }} &#x20ac;. Souhaitez-vous alimenter
                            automatiquement le formulaire ?
                        </b>
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cerfaNumber === '2571SD'">
                    <v-col cols="12">
                        <b class="text-center">
                            bobbee a trouvé le montant de l'acompte à déclarer. Souhaitez-vous
                            alimenter automatiquement le formulaire ?
                        </b>
                    </v-col>
                </v-row>
            </div>
        </oss-dialog>
        <oss-dialog
            v-if="ibanLimitDialog"
            v-model="ibanLimitDialog"
            title="Limite DGFIP"
            @valid="ibanLimitDialog = false"
            :validTitle="'OK'"
        >
            <div style="width: 750px">
                <v-col cols="12" class="pt-3">
                    <p class="text-center">
                        La DGFIP fixe le nombre de comptes bancaires maximal à trois pour les
                        paiements.
                    </p>
                </v-col>
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import _ from "lodash";

import { Apollo } from "@/decorators";
import { User } from "@/store/store";

import { DeclarationFormEngine } from "./DeclarationFormEngine";

import moment from "moment-timezone";

import gql from "graphql-tag";

import BANK_ACCOUNTS from "@/graphql/bank/BankAccounts.gql";
import COMPANY from "@/graphql/company/CompanyFromSiret.gql";
import DECLARATION_FORM from "@/graphql/declarationForm/DeclarationForm.gql";
import DECLARATION_TAX_FORM from "@/graphql/declarationForm/DeclarationTaxForm.gql";
import UPSERT_DECLARATION from "@/graphql/declaration/UpsertDeclaration.gql";
import DECLARATION from "@/graphql/declaration/Declaration.gql";
import GENERATE_DECLARATION from "@/graphql/declaration/GenerateDeclaration.gql";
import VALIDATE_DECLARATION_WITHOUT_SENDING_MTAE from "@/graphql/declaration/ValidateDeclarationWithoutSendingToMTAE.gql";
import GET_DECLARATION_DATA from "@/graphql/declaration/DeclarationData.gql";
import COMPUTE_AUTO_VAT_BALANCE from "@/graphql/declaration/ComputeAutoVatBalance.gql";
import COMPUTE_ASSIST_VAT_BALANCE from "@/graphql/declaration/ComputeAssistVatBalance.gql";
import COMPUTE_CLOSURE_VAT_REGULARIZATION from "@/graphql/declaration/ComputeClosureVatRegularization.gql";
import { getAccountingFirmFromUser } from "@/services/companyServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { PreviousVatCredit } from "../../../../../backend/src/common/types/taxformTypes";

function getFormTestJson(formTest) {
    const json = require("../../../../../backend/src/data/declarations/" + formTest + ".json");
    return json;
}

@Component({
    emits: ["validUpdate", "declarationSent", "back"],
})
export class DeclarationForm extends DeclarationFormEngine {
    @Prop({ default: "" }) formTest: string;
    @Prop({ default: "" }) formId: string;
    @Prop({ default: "" }) decId: string;
    @Prop({ default: false }) hideHeader: boolean;
    @Prop({ default: "" }) declaration: any;
    @Prop({ default: null }) auditForm: Array<any>;
    @Prop({ default: "" }) acrId: string;
    @Prop({ default: "" }) auditCheckResult: any;
    @Prop({ default: null }) vatItems: Array<any>;
    @Prop({ default: false }) autoVatMode: boolean;
    @Prop({ default: false }) assistVatMode: boolean;
    @Prop({ default: false }) closureVatMode: boolean;
    @Prop({ default: null }) closureVatItems: Array<any>;
    @Prop({ default: null }) closureLastDeclarationData: Array<any>;
    @Prop({ default: null }) assistVatItems: Array<any>;
    @Prop({ default: null }) autoVatExtraData: any;
    @Prop({ default: null }) previousVatCredit: PreviousVatCredit;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: null }) cerfaNumber: string;
    @Prop({ default: null }) propsStartDate: string;
    @Prop({ default: null }) propsEndDate: string;

    date = "";
    valid: boolean = false;

    confirmDialog: boolean = false;

    confirmWithoutSendingDialog: boolean = false;

    reloadKey = 0;

    requestsLoaded = {
        company: false,
    };

    siretNm1_: string = "";

    selectedFormId = null;

    status = "EDITION";

    autoDepositValidationDialog: boolean = false;

    ibanLimitDialog: boolean = false;

    // old version
    get errorMessage() {
        if (
            this.cerfaNumber === "3310CA3" &&
            this.form.taxedOperationsFields &&
            this.form.grossVatFields
        ) {
            let taxedOperationsFieldsTotal = 0;
            for (const key of this.form.taxedOperationsFields) {
                const value = this.fields[key];
                if (value) {
                    taxedOperationsFieldsTotal += value;
                }
            }
            let grossVatFieldsTotal = 0;
            for (const key of this.form.grossVatFields) {
                const value = this.fields[key];
                if (value) {
                    grossVatFieldsTotal += value;
                }
            }
            if (taxedOperationsFieldsTotal - grossVatFieldsTotal !== 0) {
                return "Le total des opérations taxées ne correspond pas au total des bases hors taxes.";
            }
            return "";
        }
        return "";
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get siret() {
        return this.$store.state.selected_company.siret;
    }

    get declarationFormId() {
        if (this.selectedFormId) {
            return this.selectedFormId;
        }
        return this.formId;
    }

    set declarationFormId(data) {
        this.selectedFormId = data;
    }

    declarationId_ = "";
    get declarationId() {
        if (this.decId) {
            return this.decId;
        }
        if (this.declarationId_) {
            return this.declarationId_;
        }
        return "";
    }

    set declarationId(data) {
        this.declarationId_ = data;
    }

    startDate_ = "";
    get startDate() {
        if (this.startDate_) {
            return this.startDate_;
        }
        return this.propsStartDate;
    }

    set startDate(data) {
        this.startDate_ = data;
    }

    endDate_ = "";
    get endDate() {
        if (this.endDate_) {
            return this.endDate_;
        }
        return this.propsEndDate;
    }

    set endDate(data) {
        this.endDate_ = data;
    }

    get siretNm1() {
        if (this.siretNm1_) {
            return this.siretNm1_;
        }
        return this.siret;
    }

    set siretNm1(value) {
        this.siretNm1_ = value;
    }

    get accountingPeriodId() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod.id;
    }

    get amountToPayField() {
        return this.form.amountDeclaredKey;
    }

    get loading() {
        if (this.$apollo.queries) {
            const requests = Object.keys(this.$apollo.queries);
            const result = requests.reduce(
                (acc, req) => acc || this.$apollo.queries[req].loading,
                false,
            );
            return result;
        }
        return false;
    }

    // amountToPay_: number = null
    get amountToPay() {
        // if (this.cerfaNumber === "3310CA3") {
        // if (this.amountToPay_ !== null && this.amountToPay_ !== undefined) {
        //     return this.amountToPay_
        // }
        if (this.lastDeclarationAmount !== null) {
            if (this.fields[`${this.amountToPayField}`] - this.lastDeclarationAmount > 0) {
                return this.fields[`${this.amountToPayField}`] - this.lastDeclarationAmount;
            } else {
                return 0;
            }
        }
        return this.fields[`${this.amountToPayField}`] || 0;
        // }
    }

    // set amountToPay(value) {
    //     this.amountToPay_ = value
    // }

    // get unaffectedPaymentAmount() {
    //     const affectedPaymentAmount = this.paymentsList.reduce((acc, curr) => acc + curr.amount, 0)
    //     const amount = this.amountToPay - affectedPaymentAmount
    //     return amount
    // }

    // get affectedPaymentAmount() {
    //     const affectedPaymentAmount = this.paymentsList.reduce((acc, curr) => acc + curr.amount, 0)
    //     return affectedPaymentAmount
    // }

    get validDeclarationTitle() {
        if (
            this.paymentsList.some((pl) => pl.bankAccountId?.length && pl.amount > 0) &&
            this.cerfaNumber !== "2573SD"
        ) {
            return "Envoyer la déclaration et le paiement";
        }
        return "Envoyer la déclaration";
    }

    // get validDeclarationDisabled() {
    //     const affectedPaymentAmount = this.paymentsList.reduce((acc, curr) => acc + curr.amount, 0)
    //     if (affectedPaymentAmount > this.amountToPay) {
    //         return true
    //     }
    //     return false
    //     // for (const line of this.paymentsList) {
    //     //     if (this.paymentsList.indexOf(line) === 0) {
    //     //         continue
    //     //     }
    //     //     if (!line.bankAccountId.length) {
    //     //         return true
    //     //     }
    //     // }
    //     // return false
    // }

    isItemDisabled(item) {
        return !!this.paymentsList.find((pl) => pl.bankAccountId === item.id);
    }

    toggleConfirmDialog() {
        this.confirmDialog = !this.confirmDialog;
    }

    toggleConfirmWithoutSendingDialog() {
        this.confirmWithoutSendingDialog = !this.confirmWithoutSendingDialog;
    }

    @Watch("valid", { deep: true })
    emitValid() {
        this.$emit("validUpdate", this.valid);
    }

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    address
                    postalCode
                    city
                    profile {
                        id
                        rofs
                        vatBankAccount {
                            id
                            iban
                            bic
                        }
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.company) {
                    this.companyDetails = data.company;
                    if (
                        this.companyDetails?.profile?.vatBankAccount?.iban?.length &&
                        this.companyDetails?.profile?.vatBankAccount?.bic?.length &&
                        this.companyDetails?.profile?.vatBankAccount?.id?.length
                    ) {
                        this.paymentsList[0].bankAccountId =
                            this.companyDetails.profile.vatBankAccount.id;
                    } else if (this.bankAccounts.length) {
                        this.paymentsList[0].bankAccountId = this.bankAccounts[0].id;
                    }
                }
            }
        },
    })
    companyDetails: any = {
        name: "",
        address: "",
        postatCode: "",
        city: "",
        profile: {
            rofs: [],
            vatBankAccount: {
                id: "",
                iban: "",
                bic: "",
            },
        },
    };

    @Apollo({
        query: BANK_ACCOUNTS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.bankAccounts?.length) {
                    for (const ba of data.bankAccounts) {
                        if (ba.iban?.length > 0 && ba.bic?.length > 0) {
                            this.bankAccounts.push(ba);
                        } else {
                            this.incompleteBankAccounts.push(ba);
                        }
                    }
                }
            }
        },
    })
    bankAccounts = [];

    incompleteBankAccounts = [];

    @Apollo({
        query: COMPANY,
        variables() {
            return {
                siret: this.siret,
            };
        },
        skip() {
            return !this.siret;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companyFromSiret && data.companyFromSiret.company) {
                    this.company = data.companyFromSiret.company;
                    this.requestsLoaded.company = true;
                    if (this.form && Object.keys(this.form).length) {
                        this.loadFields();
                    }
                }
            }
        },
    })
    company: any = null;

    @Apollo({
        query() {
            return this.formId ? DECLARATION_FORM : DECLARATION_TAX_FORM;
        },
        variables() {
            if (this.formId) {
                return {
                    id: this.formId,
                };
            }
            return {
                companyId: this.companyId,
                cerfaNumber: this.cerfaNumber,
                startDate: this.startDate,
                endDate: this.endDate,
                accountingPeriodId: this.accountingPeriodId,
                skipGetForm: false,
            };
        },
        skip() {
            if (!this.formId) {
                return (
                    !this.companyId ||
                    !this.cerfaNumber ||
                    !this.startDate ||
                    !this.endDate ||
                    !this.accountingPeriodId
                );
            }
            return this.auditForm || this.formTest;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarationTaxForm?.result) {
                    if (data?.declarationTaxForm?.result?.declarationForm) {
                        this.form = {
                            id: data.declarationTaxForm.result.declarationForm.id,
                            title: data.declarationTaxForm.result.declarationForm.name,
                            year: data.declarationTaxForm.result.declarationForm.year,
                            tables: data.declarationTaxForm.result.declarationForm.form.form,
                            availabilityDate:
                                data.declarationTaxForm.result.declarationForm.availabilityDate,
                            amountDeclaredKey:
                                data.declarationTaxForm.result.declarationForm.form
                                    .amountDeclaredKey,
                        };
                        if (
                            data.declarationTaxForm.result.declarationForm.form
                                .taxedOperationsFields?.length
                        ) {
                            this.form.taxedOperationsFields =
                                data.declarationTaxForm.result.declarationForm.form.taxedOperationsFields;
                        }
                        if (
                            data.declarationTaxForm.result.declarationForm.form.grossVatFields
                                ?.length
                        ) {
                            this.form.grossVatFields =
                                data.declarationTaxForm.result.declarationForm.form.grossVatFields;
                        }
                        if (data.declarationTaxForm.result.autoDeposit) {
                            if (this.cerfaNumber === "3514SD") {
                                this.vatAutoDepositAmount =
                                    data.declarationTaxForm.result.autoDeposit.amount;
                                this.vatAutoDepositField =
                                    data.declarationTaxForm.result.autoDeposit.field;
                                this.vatAutoDepositCarriedForwardAmount =
                                    data.declarationTaxForm.result.autoDeposit.carriedForwardCreditAmount;
                                this.vatAutoDepositCarriedForwardField =
                                    data.declarationTaxForm.result.autoDeposit.carriedForwardCreditField;
                                this.autoDepositValidationDialog = true;
                            } else if (this.cerfaNumber === "2571SD") {
                                this.corporateTaxAutoDeposit.push(
                                    ...data.declarationTaxForm.result.autoDeposit.amounts,
                                );
                                this.autoDepositValidationDialog = true;
                            }
                        }
                        this.loadFields();
                    } else if (data?.declarationTaxForm?.result?.errorMessage) {
                        this.formErrorMessage = data.declarationTaxForm.result.errorMessage;
                    }
                } else if (data?.declarationForm) {
                    this.form = {
                        id: data.declarationForm.id,
                        title: data.declarationForm.name,
                        year: data.declarationForm.year,
                        tables: data.declarationForm.form.form,
                        availabilityDate: data.declarationForm.availabilityDate,
                        amountDeclaredKey: data.declarationForm.form.amountDeclaredKey,
                    };
                    if (data.declarationForm.form.taxedOperationsFields?.length) {
                        this.form.taxedOperationsFields =
                            data.declarationForm.form.taxedOperationsFields;
                    }
                    if (data.declarationForm.form.grossVatFields?.length) {
                        this.form.grossVatFields = data.declarationForm.form.grossVatFields;
                    }
                    this.loadFields();
                }
            }
        },
    })
    form: any = {};

    formErrorMessage: string = "";

    vatAutoDepositAmount: number = null;

    vatAutoDepositField: string = "";

    vatAutoDepositCarriedForwardAmount: number = null;

    vatAutoDepositCarriedForwardField: string = "";

    corporateTaxAutoDeposit: { field: string; amount: number }[] = [];

    get corporateTaxAutoDepositAmount() {
        let totalDepositAmount = 0;
        if (this.cerfaNumber === "2571SD" && this.corporateTaxAutoDeposit.length) {
            for (const rate of this.corporateTaxAutoDeposit) {
                totalDepositAmount += rate.amount;
            }
        }
        return totalDepositAmount;
    }

    get autoDepositButtonDisplay() {
        if (
            (this.vatAutoDepositAmount && this.vatAutoDepositField) ||
            this.corporateTaxAutoDeposit.length
        ) {
            return true;
        }
        return false;
    }

    @Apollo({
        query: DECLARATION,
        variables() {
            return {
                id: this.decId,
            };
        },
        skip() {
            return !this.decId || this.declaration;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.declaration) {
                    this.dbFields = data.declaration.data;
                    this.fields = data.declaration.data;
                    this.declarationFormId = data.declaration.form.id;
                    // this.formId = data.declaration.form.id
                    this.siret = data.declaration.company.siret;
                    this.status = data.declaration.status;
                    this.startDate = data.declaration.startDate;
                    this.endDate = data.declaration.endDate;
                }
            }
        },
    })
    dbFields: any = {};

    @Apollo({
        query: GET_DECLARATION_DATA,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                declarationFormId: this.declarationFormId,
            };
        },
        skip() {
            return !this.isAutonomousUser || this.auditForm !== null;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.dbFields = data.declarationData.data;
                    this.fields = data.declarationData.data;
                }
            }
        },
    })
    data: any = {};

    @Apollo({
        query: COMPUTE_AUTO_VAT_BALANCE,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                declarationFormId: this.form.id,
                items: this.vatItems,
                vatStartPeriodDate: this.startDate,
                vatEndPeriodDate: this.endDate,
                previousVatCredit: this.previousVatCredit,
            };
        },
        skip() {
            return (
                !this.vatItems ||
                !this.endDate ||
                !this.startDate ||
                !this.form.id ||
                this.assistVatItems
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.autoVatBalance = JSON.parse(
                        JSON.stringify(data.computeAutoVatBalance.result),
                    );
                    this.fields = this.autoVatBalance;
                }
            }
        },
    })
    autoVatBalance: any = {};

    @Apollo({
        query: COMPUTE_ASSIST_VAT_BALANCE,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                declarationFormId: this.form.id,
                items: this.assistVatItems,
                vatEndPeriodDate: this.endDate,
                vatStartPeriodDate: this.startDate,
                previousVatCredit: this.previousVatCredit,
            };
        },
        skip() {
            return !this.assistVatItems || !this.form.id || !this.endDate || !this.startDate;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.assistVatBalance = JSON.parse(
                        JSON.stringify(data.computeAssistVatBalance.result),
                    );
                    this.fields = this.assistVatBalance;
                }
            }
        },
    })
    assistVatBalance: any = {};

    @Apollo({
        query: COMPUTE_CLOSURE_VAT_REGULARIZATION,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                declarationFormId: this.form.id,
                items: this.closureVatItems,
                lastDeclarationData: this.closureLastDeclarationData,
            };
        },
        skip() {
            return !this.form.id || !this.closureVatItems;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.computeClosureVatRegularization?.result) {
                    this.closureVatBalance = JSON.parse(
                        JSON.stringify(data.computeClosureVatRegularization.result.data),
                    );
                    this.fields = this.closureVatBalance;

                    if (data.computeClosureVatRegularization.result.lastDeclarationAmount) {
                        this.lastDeclarationAmount =
                            data.computeClosureVatRegularization.result.lastDeclarationAmount;
                    }
                }
            }
        },
    })
    closureVatBalance: any = {};

    lastDeclarationAmount: number = null;

    loadFields() {
        const defaultFields = this.readForm(this.form);
        if (!this.decId && !this.declaration && !this.auditCheckResult && !this.vatItems) {
            this.fields = defaultFields;
            if (
                this.fields["period"] !== undefined &&
                this.startDate &&
                (this.cerfaNumber === "2571SD" ||
                    this.cerfaNumber === "3514SD" ||
                    this.cerfaNumber === "1329AC")
            ) {
                this.fields["period"] = this.startDate.substring(5, 7);
            }
        }
    }

    beforeMount() {
        if (this.auditCheckResult) {
            this.fields = this.auditCheckResult;
        }
        if (this.auditForm) {
            this.form = this.auditForm;
            this.loadFields();
            this.$emit("validUpdate", this.valid);
        }
        if (this.declaration) {
            this.fields = this.declaration.data;
            this.declarationFormId = this.declaration.form.id;
            this.startDate = moment(this.declaration.startDate).format("YYYY-MM-DD");
            this.endDate = moment(this.declaration.endDate).format("YYYY-MM-DD");
            this.status = this.declaration.status;
        }
        if (this.formTest) {
            this.form = getFormTestJson(this.formTest);
            this.startDate = moment("2023-01-01").format("YYYY-MM-DD");
            this.endDate = moment("2023-01-01").format("YYYY-MM-DD");
            this.loadFields();
        }
    }

    // async beforeMount() {
    //     if (this.auditCheckResult) {
    //         this.fields = this.auditCheckResult
    //     }
    //     if (this.auditForm) {
    //         this.form = this.auditForm
    //         this.loadFields()
    //         this.$emit('validUpdate', this.valid)
    //     }
    //     if (this.declaration) {
    //         this.fields = this.declaration.data
    //         this.declarationFormId = this.declaration.form.id
    //         this.status = this.declaration.status
    //     }
    //     if (this.formTest) {
    //         this.form = getFormTestJson(this.formTest)
    //         this.loadFields()
    //     }
    // }

    @Watch("fields", { deep: true })
    onFieldsChanged() {
        this.update();
    }

    //
    // rules
    //

    // getRules(field) {
    //     if (!field.ruleName) return undefined;
    //     if (field.ruleName === "positive") {
    //         return this.positive;
    //     }
    //     return undefined;
    // }

    // getFieldRules(field) {
    //     return field.mandatoryConditionField
    //         ? [(v) => !!v || "Ce champs est obligatoire"]
    //         : undefined;
    // }

    // get positive() {
    //     return [(v) => v >= 0 || "Le montant ne peut pas être négatif"];
    // }

    getHint(field) {
        if (!field || !field.minAmount) {
            return null;
        }
        const hint = this.compareMinAmount(field);
        return hint;
    }

    compareMinAmount(field) {
        return (
            this.fields[field.key] > field.minAmount ||
            `Dispense d'acompte si le montant est inférieur à ${field.minAmount} €`
        );
    }

    getMandatoryConditionField(field) {
        if (field) {
            return !this.fields[field];
        }
        return false;
    }

    fillAutoDepositInDeclaration() {
        if (this.cerfaNumber === "3514SD") {
            this.fields[this.vatAutoDepositField] = this.vatAutoDepositAmount;
            if (this.vatAutoDepositCarriedForwardAmount && this.vatAutoDepositCarriedForwardField) {
                this.fields[this.vatAutoDepositCarriedForwardField] =
                    this.vatAutoDepositCarriedForwardAmount;
            }
            this.autoDepositValidationDialog = false;
        } else if (this.cerfaNumber === "2571SD") {
            for (const rate of this.corporateTaxAutoDeposit) {
                this.fields[rate.field] = rate.amount || 0;
            }
            this.autoDepositValidationDialog = false;
        }
    }

    //
    // save
    //

    async save(beforeValidation: boolean = false) {
        const declaration = await this.$apollo.mutate({
            mutation: UPSERT_DECLARATION,
            variables: {
                id: this.declarationId,
                data: this.fields,
                companyId: this.companyId,
                declarationFormId: this.form.id,
                status: "EDITION",
                accountingPeriodId: this.accountingPeriodId,
                startDate: moment(this.startDate).utc(true).format(),
                endDate: moment(this.endDate).utc(true).format(),
            },
        });
        this.declarationId = declaration.data.upsertDeclaration.id;
        if (declaration && !beforeValidation) {
            this.$emit("declarationSent");
        }
    }

    paymentsList = [{ bankAccountId: "", amount: 0 }];

    setAmountToPay() {
        // if (this.cerfaNumber === "3310CA3") {
        this.paymentsList[0].amount = this.amountToPay;
        // }
    }

    addPaymentLine() {
        if (this.paymentsList.length === 3) {
            this.ibanLimitDialog = true;
            return;
        }
        this.paymentsList.push({ bankAccountId: "", amount: 0 });
    }

    deletePaymentLine(index) {
        this.paymentsList.splice(index, 1);
    }

    async generate() {
        const accountingFirm = await getAccountingFirmFromUser(this.$apollo, this.currentUser);
        if (accountingFirm?.id) {
            await this.save(true);
            const result = await this.$apollo.mutate({
                mutation: GENERATE_DECLARATION,
                variables: {
                    declarationID: this.declarationId,
                    companyID: this.companyId,
                    accountantID: accountingFirm.id,
                    extraData: this.autoVatExtraData,
                    paymentsList: this.paymentsList,
                },
            });
            if (result) {
                if (
                    this.assistVatMode ||
                    this.autoVatMode ||
                    (this.$route.name === "declaration" && this.declarationId)
                ) {
                    this.$emit("declarationSent");
                } else {
                    this.$router.push({
                        name: "declaration",
                        params: { decId: this.declarationId },
                    });
                }
            }
            if (this.$route.name === "declaration-test") {
                const testResult = this.filterForm();
                this.saveFile(testResult);
            }
            this.toggleConfirmDialog();
            location.reload();
        }
    }

    async validateWithoutSendingToMTAE() {
        const accountingFirm = await getAccountingFirmFromUser(this.$apollo, this.currentUser);
        if (accountingFirm?.id) {
            await this.save(true);
            const result = await this.$apollo.mutate({
                mutation: VALIDATE_DECLARATION_WITHOUT_SENDING_MTAE,
                variables: {
                    declarationID: this.declarationId,
                    extraData: this.autoVatExtraData,
                },
            });
            if (result) {
                if (
                    this.assistVatMode ||
                    this.autoVatMode ||
                    (this.$route.name === "declaration" && this.declarationId)
                ) {
                    this.$emit("declarationSent");
                } else {
                    this.$router.push({
                        name: "declaration",
                        params: { decId: this.declarationId },
                    });
                }
            }
            if (this.$route.name === "declaration-test") {
                const testResult = this.filterForm();
                this.saveFile(testResult);
            }
            this.toggleConfirmWithoutSendingDialog();
        }
    }

    saveFile(amounts) {
        const data = JSON.stringify(amounts, null, 2);
        const filename = `${amounts.declarationFormKey}.json`;
        const blob = new Blob([data], { type: "text/plain" });

        const link = document.createElement("a");
        link.setAttribute("style", "display:none");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }

    isSubTitle(row) {
        if (!row.values) return false;
        return !row.values.filter(
            (x) => x.type !== "empty" && x.type !== "text" && x.type !== "title",
        ).length;
    }

    isDisabledValidateButton() {
        if (this.cerfaNumber === "3030SD") {
            return true;
        }
        if (["EDITION", "ERROR"].includes(this.status) && !this.errorMessage) {
            return !this.valid;
        }
        return true;
    }

    saveAuditForm() {
        const data = this.fields;
        return data;
    }

    getBackAction() {
        if (this.assistVatMode || this.autoVatMode || this.closureVatMode) {
            return this.$emit("back");
        }
        return this.$router.push({ name: "taxForms" });
    }

    isReadonly(field) {
        if (!field) {
            debugger;
            return true;
        }
        return !["EDITION"].includes(this.status) || field.readonly;
    }
}

export default toNative(DeclarationForm);
</script>

<style lang="scss">
.default_card_wm > .row > .col:not(:first-child) > .row > .col.titleclass {
    font-size: 14px !important;
}
</style>
